import { Grid, PageLoading, PageResponse, cmsService } from '../..'
import { FilmList, HeaderCarousel } from '../../components/allComponents'
import { FC, Suspense } from 'react'

import { HomePageResponse } from './models'
import { Meta } from '../../subcomponents'
import { useAsync } from 'react-async'
import { FilmListMode } from '@vista-digital/occ-ui'
import { FilmListComponentProps } from '../../components/filmList'

export const HomePage: FC = () => {
    const { data, isPending } = useAsync<HomePageResponse>({
        promiseFn: cmsService.loadPageComponents,
        data: new HomePageResponse(),
    })

    if (isPending || !data) return <PageLoading />

    const filmListProps: FilmListComponentProps = {
        filmListProps: data.components.FilmList,
        mode: data.components.FilmList.gridMode ? FilmListMode.Grid : FilmListMode.Carousel,
        componentId: 'home-page-film-list',
    }

    return (
        <>
            <Meta page={data}></Meta>
            <Suspense fallback={<PageLoading />}>
                <HeaderCarousel slides={data.components.HeaderCarousel} />
                <div className="container-lg container-lg padding">
                    <FilmList {...filmListProps} />
                    <Grid rows={data.gridContent}></Grid>
                </div>
            </Suspense>
        </>
    )
}
